import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/logo-gem.svg")